module.exports = __webpack_public_path__ + "assets/exclamation.be7678ef.svg";